import { useEffect } from 'react';
import { useSelector } from 'react-redux';


const CustomColor = () => {
  const customRoot = useSelector((state) => state.navroot.data?.custom_root);

  function hexToRgb(hex) {
    hex = hex.replace(/^#/, '');

    if (hex.length === 3) {
      hex = hex.split('').map(function (hexChar) {
        return hexChar + hexChar;
      }).join('');
    }
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return { red: r, green: g, blue: b };
  }

  const getColor = function (customRoot) {
    if (!customRoot?.content_color) {
      return { red: 40, green: 51, blue: 74 }
    }
    return hexToRgb(customRoot.content_color)
  }
  const color = getColor(customRoot)

  function getLuminance(r, g, b) {
    const toLinear = (c) => {
      c = c / 255;
      return c <= 0.03928
        ? c / 12.92
        : Math.pow((c + 0.055) / 1.055, 2.4);
    };

    const R = toLinear(r);
    const G = toLinear(g);
    const B = toLinear(b);

    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  }

  function getContrastRatio(lum1, lum2) {
    const brightest = Math.max(lum1, lum2);
    const darkest = Math.min(lum1, lum2);
    return (brightest + 0.05) / (darkest + 0.05);
  }

  function getAccessibleTextColor(r, g, b) {
    const backgroundLum = getLuminance(r, g, b);
    const whiteLum = getLuminance(255, 255, 255);
    const blackLum = getLuminance(0, 0, 0);

    const contrastWithWhite = getContrastRatio(backgroundLum, whiteLum);
    const contrastWithBlack = getContrastRatio(backgroundLum, blackLum);

    if (!customRoot?.content_color) {
      return [255, 255, 255]
    } else {
      if (contrastWithBlack >= 4.5) {
        return [0, 0, 0];
      } else if (contrastWithWhite >= 4.5) {
        return [255, 255, 255]; // White
      } else {
        return contrastWithWhite > contrastWithBlack
          ? [255, 255, 255]
          : [0, 0, 0];
      }
    }
  }

  const textColor = getAccessibleTextColor(color.red, color.green, color.blue);

  useEffect(() => {
    document.documentElement.style.setProperty('--bs-minisiteColor-red', color.red);
    document.documentElement.style.setProperty('--bs-minisiteColor-green', color.green);
    document.documentElement.style.setProperty('--bs-minisiteColor-blue', color.blue);
    document.documentElement.style.setProperty('--bs-minisiteContrast-rgb', textColor);
  }, [customRoot]); 

};

export default CustomColor;